import React from "react";
import img1 from "../../images/ourCompany.png";
import { Box, Grid, Typography } from "@mui/material";
import { mainHeading, subHeading } from "../../styles/style";

export default function AboutCompany() {
  return (
    <>
      <Box mt={8} sx={{ height:{xs:'100%', md:'70vh'}, bgcolor: "#F6F8F9" }}>
        <Grid container>
          <Grid item md={5}>
            <Box sx={{height:{xs:'100%', md:'70vh'}}}>
              <img
                src={img1}
                alt="bannerCouple"
                style={{height:'100%' , width: "100%" }}
              />
            </Box>
          </Grid>
          <Grid item md={7}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "start",
                flexDirection: "column",
                height: "100%",
                fontFamily: "Inter",
                p: 8,
              }}
            >
              <Typography sx={subHeading}>Experience With PPLACD</Typography>
              <Typography sx={mainHeading}>A word From Our Clients</Typography>
              <Box sx={{ fontFamily:'Inter', fontWeight:400, opacity:'.5', }}>
                <Typography mt={3} sx={{fontSize:'16px'}}>
                  Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a
                  nunc nibh volutpat. Massa mattis molestie amet dui volutpat.
                  Tellus lacinia pulvinar pharetra viverra morbi tincidunt mi
                  mus. Lobortis maecenas pulvinar pretium est morbi ut diam
                  pulvinar. Pellentesque id lacus id elit leo cursus purus
                  tempus tortor.
                </Typography>

                <Typography mt={2} sx={{fontSize:'16px'}}>
                  Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a
                  nunc nibh volutpat. Massa mattis molestie amet dui volutpat.
                  Tellus lacinia pulvinar pharetra viverra morbi tincidunt mi
                  mus. Lobortis maecenas pulvinar pretium est morbi ut diam
                  pulvinar. Pellentesque id lacus id elit leo cursus purus
                  tempus tortor. Amet ultricies proin egestas egestas
                  pellentesque adipiscing euismod sit imperdiet.
                </Typography>

                <Typography mt={2} sx={{fontSize:'16px'}}>
                  Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a
                  nunc nibh volutpat. Massa mattis molestie amet dui volutpat.
                  Tellus lacinia pulvinar pharetra viverra morbi tincidunt mi
                  mus. Lobortis maecenas.
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
